import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage, getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BottomBarItemColorFill} from '@Components/poster-editor/components/poster-editor-bottom-bar/components/bottom-bar-item-color-fill';
import {getUrlForImageItemBigTierScreenSize} from '@Libraries/image-item.library';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {getAssetUrl} from '@Utils/s3.util';
import {getCompatibleImageFileExtension} from '@Utils/image.util';
import {useAppSelector} from '@/hooks';
import styles from './background-item-fill-item.module.scss';

export function BackgroundItemFillItem(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentBackgroundObject = useAppSelector(getCurrentPageBackground);

  if (!currentBackgroundObject || !currentPageObject) {
    return null;
  }

  const currentPage = window.posterEditor?.whiteboard?.pages.getPage(currentPageObject.hashedID);

  if (!currentPage) {
    return null;
  }

  const getImg = (src: string): ReactElement<any> => {
    return <img className={`${styles.img} radius-4 border-s-standard`} src={src} alt={window.i18next.t('pmwjs_image_preview')} />;
  };

  const getFillItem = (): ReactElement<any> => {
    switch (currentBackgroundObject.details.type) {
      case BackgroundTypeName.COLOR:
        if (currentBackgroundObject.details.fill.fillType === FillTypes.NONE) {
          return getImg(getAssetUrl(`poster-editor-thumbnails/transparent.${getCompatibleImageFileExtension('webp')}`));
        }
        return <BottomBarItemColorFill type={currentBackgroundObject.details.fill.fillType} color={currentBackgroundObject.details.fill.fillColor} />;
      case BackgroundTypeName.IMAGE:
        if (currentBackgroundObject.details.imageBackgroundItemObject.hashedFilename && currentBackgroundObject.details.imageBackgroundItemObject.imageSource) {
          return getImg(
            getUrlForImageItemBigTierScreenSize(
              currentBackgroundObject.details.imageBackgroundItemObject.hashedFilename,
              currentBackgroundObject.details.imageBackgroundItemObject.imageSource
            )
          );
        }
        if (currentBackgroundObject.details.imageBackgroundItemObject.uploadingImageData?.dataUrl) {
          return getImg(currentBackgroundObject.details.imageBackgroundItemObject.uploadingImageData.dataUrl);
        }
        throw new Error('Unable to get image source for image background');
      default:
        throw new Error(`Unhandled backgroundDropDownItem`);
    }
  };

  return getFillItem();
}
